module.exports = __webpack_public_path__ + "static/media/cat-g119d2830c_640.13a4b77b.jpg";